import {SupportedLanguage} from '@web-libs/core/internationalization/internationalization.types';

export class Locales {
    static readonly DE: SupportedLanguage = "de"
    static readonly EN: SupportedLanguage = "en"
    static readonly FR: SupportedLanguage = "fr"
    static readonly ES: SupportedLanguage = "es"
    static readonly PL: SupportedLanguage = "pl"
    static readonly RU: SupportedLanguage = "ru"
    static readonly TR: SupportedLanguage = "tr"
    static readonly UK: SupportedLanguage = "uk"
    static readonly RO: SupportedLanguage = "ro"
    static readonly IT: SupportedLanguage = "it"
    static readonly AR: SupportedLanguage = "ar"

    static toArray(): SupportedLanguage[] {
        return [Locales.DE, Locales.EN, Locales.FR, Locales.ES, Locales.PL, Locales.RU, Locales.TR, Locales.UK, Locales.RO, Locales.IT, Locales.AR]
    }

    static getDefaultLocale(): SupportedLanguage {
        return Locales.DE
    }
}

export const locales = Locales.toArray()

export function hasPathLocale(path: string): boolean {
    return locales.some((locale) => path.startsWith(`/${locale}/`) || path === `/${locale}`)
}
